import { render, staticRenderFns } from "./SSelectSubstances.vue?vue&type=template&id=32f21f69"
import script from "./SSelectSubstances.vue?vue&type=script&lang=js"
export * from "./SSelectSubstances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports